const siteTags = ['IDEAL_CUSTOMER_PROFILE'];
export default siteTags;
